import { Mapper } from '../../../common/ddd/mapper.base';
import { IAnalyticsActivityEnum } from '../../../common/enum/analytics-activity/analytics-activity.enum';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { SelfTimeInAppGoalEntity } from '../../../core/domain/entities/goals/app-goals/self-time-in-app-goal.entity';
import { GetSelfGoalSummaryResponseDto } from '../../../interface/dtos/goals/get-self-goal-summaries.response.dto';

export interface ISelfTimeInAppGoalPersistenceResponse {
  [IAnalyticsActivityEnum.TotalDuration]: string;
}

export class SelfTimeInAppGoalMapper
  implements Mapper<SelfTimeInAppGoalEntity, any>
{
  toDomain(
    record: ISelfTimeInAppGoalPersistenceResponse
  ): SelfTimeInAppGoalEntity {
    return SelfTimeInAppGoalMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfTimeInAppGoalPersistenceResponse
  ): SelfTimeInAppGoalEntity {
    const entity = SelfTimeInAppGoalEntity.create({
      appMetric: Number(record[IAnalyticsActivityEnum.TotalDuration]),
    });
    return entity;
  }

  toResponse(entity: SelfTimeInAppGoalEntity): GetSelfGoalSummaryResponseDto {
    return SelfTimeInAppGoalMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfTimeInAppGoalEntity
  ): GetSelfGoalSummaryResponseDto {
    return {
      currentValue: formatDuration(entity.appMetric),
      percentageDifference: entity.deviationFromGoalPercentage,
      formattedPercentageDifference: formatDeviation(
        entity.deviationFromGoalPercentage
      ),
    };
  }
}
